import TabToggle from 'components/commons/tab-toogle'
import { InlineError, Input } from 'avo-ui'

export const SEOSetting = ({ sectionRef, productDetail, onChangeForm, errorForm }) => {
    return (
        <div ref={sectionRef?.seo_setting}>
            <TabToggle
                title={'SEO Setting'}
                content={
                    <div className={'flex space-x-16'}>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>SEO Title</div>
                                <Input
                                    className={'flex-1'}
                                    name={'meta_title'}
                                    placeholder={'Masukkan meta title'}
                                    value={productDetail?.meta_title}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.meta_title} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Slug</div>
                                <Input
                                    className={'flex-1'}
                                    name={'slug'}
                                    placeholder={'Masukkan slug'}
                                    value={productDetail?.slug}
                                    pattern={/[a-z0-9\-]+$/}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.slug} />
                            </div>
                        </div>
                        <div className={'flex-1 space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Description</div>
                            <Input
                                type={'text-area'}
                                className={'flex-1'}
                                name={'meta_description'}
                                placeholder={'Masukkan meta description'}
                                value={productDetail?.meta_description}
                                row={5}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.meta_description} />
                        </div>
                    </div>
                }
            />
        </div>
    )
}
